const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/Page.tsx';
import { PageLayout } from '../layout/PageLayout';
import { AppBarMain } from './DashboardPage/AppBar/AppBar';
import * as React from 'react';
import { CardContent } from '@mui/material';
import PageCardComponent from 'App/components/PageCard/PageCardComponent';
import { MessageDescriptor } from '@formatjs/intl';
import GoBackToDashboardButton from 'App/pages/GoBackToDashboardButton';
import { useText } from '@cistec/common_web/utils/intlUtils';

export interface IPageProps {
    title: string | MessageDescriptor;
    iconClass: string;
    children: React.ReactNode;
}

export const Page = (props: IPageProps) => {
    const title = useText(props.title);

    return (
        <PageLayout appBar={<AppBarMain />}>
            <GoBackToDashboardButton />
            <PageCardComponent title={title} titleIcon={props.iconClass}>
                <CardContent>{props.children}</CardContent>
            </PageCardComponent>
        </PageLayout>
    );
};
